import { FC, PropsWithChildren } from 'react';
import css from './BlankBlockContainer.module.scss';

export const BlankBlockContainer: FC<PropsWithChildren> = ({ children }) => (
  <div className={css.blank__container}>{children}</div>
);
